import categories from 'app/components/common/categories/category-service';
import { Icon } from '@iconify/react';
import { BodyText } from '@make-software/cspr-design';
import { StyledChipsTag } from 'app/components/common/common-styles';

interface CategoryTagProps {
  name: string;
}

export const CategoryTag: React.FC<CategoryTagProps> = ({ name }) => {
  let category = categories.find((cat) => cat.name.toLowerCase() === name.toLowerCase());

  if (!category) {
    category = categories[categories.length - 1];
  }

  return (
    <StyledChipsTag color={category.color}>
      <Icon icon={category.icon} color={category.color} width="18" height="18" />
      <BodyText size={3} scale={'xs'}>
        {category.name}
      </BodyText>
    </StyledChipsTag>
  );
};
